import { Modal } from "newui/components/ui/Modal";
import { MfaSettingsSection } from "newui/features/Settings/components/Security/MfaSettingsSection";

export interface TwoFactorAuthModalProps {
	isOpen: boolean;
	onClose: () => void;
}

/**
 * PRO-731 — hosts the existing `MfaSettingsSection` (enrolment wizard,
 * regenerate/disable/re-enrol controls) inside a modal instead of rendering
 * it inline on the My Profile page.
 *
 * No header `description` here (PRO-731 follow-up) — it was a second,
 * permanently-reserved header line that every `MfaSettingsSection` state
 * duplicated with its own more relevant copy (e.g. the enrolment wizard's
 * steps, or the disabled-state paragraph), so it only ate into the modal's
 * available body height for no benefit. That's what pushed the "save your
 * recovery codes" confirmation prompt below the fold when enabling — the
 * equivalent regenerate-codes view never had this extra header line, which
 * is why the same prompt was never clipped there.
 *
 * `MfaSettingsSection`'s `onSettled` closes this modal once 2FA is fully
 * enabled or fully disabled (PRO-731 follow-up), returning the user to the
 * profile screen instead of leaving the now-settled management view open.
 */
export const TwoFactorAuthModal = ({ isOpen, onClose }: TwoFactorAuthModalProps) => (
	<Modal
		isOpen={isOpen}
		onClose={onClose}
		title="Two-Factor Authentication"
		iconType="info"
		size="md"
	>
		<MfaSettingsSection onSettled={onClose} />
	</Modal>
);
